<div [class.white]="isWhite" [class.darkmode]="darkMode">
  <span [class.no-max-width]="noMaxWidth">{{ quoteText }}</span>
</div>
